(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const container = document.getElementById('DesignSelector');
    if (!container) return;

    const formId = container.getAttribute('data-form-id');
    const productForm = document.getElementById(formId) || document.querySelector('form[action="/cart/add"]');
    if (!productForm) return;

    // Create hidden property inputs
    const propTitleLabel = container.getAttribute('data-property-title') || 'Design';
    const propHandleLabel = container.getAttribute('data-property-handle') || 'Design handle';
    const propImageLabel = container.getAttribute('data-property-image') || 'Design image';
    const requireSelection = container.getAttribute('data-require-selection') === 'true';

    const makeHidden = (name) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      return input;
    };
    const propTitle = makeHidden(propTitleLabel);
    const propHandle = makeHidden(propHandleLabel);
    const propImage = makeHidden(propImageLabel);

    productForm.appendChild(propTitle);
    productForm.appendChild(propHandle);
    productForm.appendChild(propImage);

    // UI elements
    const cards = Array.from(container.querySelectorAll('.design-card'));
    const selectedLabel = container.querySelector('.design-selector__selected-label');
    const zoomBtn = container.querySelector('.design-selector__zoom-btn');
    const dialog = container.querySelector('.design-selector__modal');
    const dialogImage = dialog?.querySelector('.design-modal__image');
    const dialogTitle = dialog?.querySelector('.design-modal__title');
    const closeBtn = dialog?.querySelector('.design-modal__close');

    let selected = null;

    // Search/filter controls
    const searchInput = container.querySelector('.design-selector__search');
    const availableOnlyCheckbox = container.querySelector('.design-selector__available-only');

    function applyFilters() {
      const q = (searchInput?.value || '').toLowerCase().trim();
      const availableOnly = availableOnlyCheckbox ? availableOnlyCheckbox.checked : false;

      cards.forEach(card => {
        const title = card.getAttribute('data-design-title').toLowerCase();
        const available = card.getAttribute('data-available') === 'true';
        const matchesText = !q || title.includes(q);
        const matchesAvailability = !availableOnly || available;
        card.style.display = (matchesText && matchesAvailability) ? '' : 'none';
      });
    }

    searchInput && searchInput.addEventListener('input', applyFilters);
    availableOnlyCheckbox && availableOnlyCheckbox.addEventListener('change', applyFilters);
    applyFilters();

    function updateSelection(card) {
      cards.forEach(c => c.setAttribute('aria-pressed', 'false'));
      if (!card) {
        selected = null;
        propTitle.value = '';
        propHandle.value = '';
        propImage.value = '';
        selectedLabel.textContent = 'No design selected';
        zoomBtn.disabled = true;
        return;
      }
      card.setAttribute('aria-pressed', 'true');
      selected = {
        title: card.getAttribute('data-design-title'),
        handle: card.getAttribute('data-design-handle'),
        image: card.getAttribute('data-design-image')
      };
      propTitle.value = selected.title;
      propHandle.value = selected.handle;
      propImage.value = selected.image;
      selectedLabel.textContent = `Selected: ${selected.title}`;
      zoomBtn.disabled = false;
    }

    cards.forEach(card => {
      card.addEventListener('click', () => {
        // If card is flagged unavailable, allow preview but not selection when requireSelection
        const available = card.getAttribute('data-available') === 'true';
        updateSelection(available ? card : card); // allow selection even if unavailable if admin wants; change to `available ? card : null` to block
      });
    });

    // Modal preview
    if (dialog && zoomBtn) {
      zoomBtn.addEventListener('click', () => {
        if (!selected) return;
        dialogImage.src = selected.image;
        dialogImage.alt = selected.title;
        dialogTitle.textContent = selected.title;
        dialog.showModal();
      });
      closeBtn && closeBtn.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => {
        const rect = dialog.querySelector('.design-modal__content').getBoundingClientRect();
        const isInside = e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;
        if (!isInside) dialog.close();
      });
    }

    // Block add-to-cart when required and not selected
    if (requireSelection) {
      const submitButtons = productForm.querySelectorAll('[type="submit"], button[name="add"]');
      const guard = (e) => {
        if (!selected) {
          e.preventDefault();
          e.stopPropagation();
          selectedLabel.textContent = 'Please select a design before adding to cart.';
          selectedLabel.classList.add('design-selector__selected-label--error');
        } else {
          selectedLabel.classList.remove('design-selector__selected-label--error');
        }
      };
      submitButtons.forEach(btn => btn.addEventListener('click', guard));
    }
  });
})();